<template>
  <v-container fluid :class="fillBackgroundClasses">
    <v-row justify="center" no-gutters>
      <v-col xs="12" md="7">
        <v-card outlined min-height="600px">
          <v-row>
            <v-col xs="2" md="3">
              <v-img class="white--text align-end" id="signup__logo__image" width="220px" :src="logo" />
            </v-col>
            <v-col xs="10" md="9">
              <v-card-subtitle class="pb-0"
                >Bienvenido a CONTPAQi® Firma Electrónica</v-card-subtitle
              >
              <v-card-text class="text--primary">
              </v-card-text>
            </v-col>
          </v-row>

          <v-progress-linear
            :indeterminate="this.isBusy"
            value="100"
            :color="this.appThemeComponentsMainColor"
          ></v-progress-linear>

          <!-- Stepper -->
          <v-stepper v-model="currentStep">
            <v-stepper-header>
              <v-stepper-step
                :color="this.appThemeComponentsMainColor"
                id="signup__terminos_condiciones__stepper"
                :complete="currentStep > 1"
                step="1"
                >Términos y condiciones</v-stepper-step
              >
              <v-divider></v-divider>
              <v-stepper-step
                :color="this.appThemeComponentsMainColor"
                id="signup__usuario_contrasena__stepper"
                :complete="currentStep > 2"
                step="2"
                >Usuario y Contraseña</v-stepper-step
              >
              <v-divider></v-divider>
              <v-stepper-step
                :color="this.appThemeComponentsMainColor"
                id="signup__informacion_personal__stepper"
                :complete="currentStep > 3"
                step="3"
                >Información personal</v-stepper-step
              >
              <v-divider></v-divider>
              <v-stepper-step 
                 :color="this.appThemeComponentsMainColor"
                 id="signup__final__stepper" 
                 step="4"
                >Final</v-stepper-step
              >
            </v-stepper-header>
            <v-stepper-items>
              <v-stepper-content step="1">
                <signup-agreements min-height="452px"></signup-agreements>
              </v-stepper-content>
              <v-stepper-content step="2">
                <signup-user-password
                  :correo="tknMail"
                  min-height="452px"
                ></signup-user-password>
              </v-stepper-content>
              <v-stepper-content step="3">
                <signup-info-adicional
                  :nombre="tknName"
                  :apellidoP="tknFamilyName"
                  :apellidoM="tknFamilySecondName"
                  min-height="452px"
                ></signup-info-adicional>
              </v-stepper-content>
              <v-stepper-content step="4">
                <signup-review min-height="452px"></signup-review>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>

          <v-card-actions>
            <v-row justify="end" class="mt-2">
              <span class="ml-5">
                ¿Ya tienes cuenta?
                <a
                  id="signup__ya_tienes_cuenta__link"
                  class="text-decoration-none blue--text lighten-2"
                  :href="identidadesSingin"
                  >Inicia sesión</a
                >
              </span>
              <v-spacer></v-spacer>
              <span>
                <v-btn
                  v-if="currentStep > 1"
                  id="signup__atras__button"
                  color="success"
                  class="mr-5"
                  @click="this.goBack"
                  :disabled="this.isBusy"
                  >Atrás</v-btn
                >
                <v-btn
                  :color="colorButton"
                  id="signup__siguiente__button"
                  class="mr-5"
                  @click="processStep"
                  :disabled="!this.canGoNext || this.isBusy"
                  :dark="currentStep === this.wizardLength && !this.isBusy"
                  >{{ textoButton }}</v-btn
                >
              </span>
            </v-row>
          </v-card-actions>

          <v-row>
            <v-col cols="12">
              <notification-container
                class="mr-5 ml-5"
              ></notification-container>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center" no-gutters>
      <v-col xs="1" md="1">
        <version-tag></version-tag>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import logo from '@/assets/LogoCONTPAQiFirma_Positivo.png'
import SignupAgreements from '@/modules/auth/components/SignupAgreements'
import SignupUserPassword from '@/modules/auth/components/SignupUserPassword'
import SignupInfoAdicional from '@/modules/auth/components/SignupInfoAdicional'
import SignupReview from '@/modules/auth/components/SignupReview'
import ConvertToken from '@/utils/ConvertToken'

import {
  panelData,
  panelActions,
  userData,
  userActions,
  pushNotification,
  appThemeData
} from '@/store/helpers'

import { signupData, signupActions } from '../store/signupWizardHelpers'

import { fielStorageData } from '@/modules/signers/store/fielStorageHelpers'

export default {
  name: 'SignupPage',
  components: {
    SignupAgreements,
    SignupUserPassword,
    SignupInfoAdicional,
    SignupReview
  },
  data() {
    return {
      logo,
      tknMail: '',
      tknName: '',
      tknFamilyName: '',
      tknFamilySecondName: '',
      tknIdentityId: '',
      colorButton: 'success',
      textoButton: 'Siguiente'
    }
  },
  created() {
    this.checkParamToken()
  },
  computed: {
    ...panelData,
    ...signupData,
    ...appThemeData,
    ...userData,
    ...fielStorageData,
    currentStep: {
      get() {
        this.setStepAppereance(this.wizardStep)
        return this.wizardStep
      }
    },
    fillBackgroundClasses: {
      get() {
        return `fill-height ${this.appThemeBackgroundWelcome}`
      }
    }
  },
  methods: {
    ...panelActions,
    ...userActions,
    ...signupActions,
    setStepAppereance(step) {
      this.textoButton = 'Siguiente'
      this.colorButton = 'success'

      if (step === this.wizardLength) {
        this.textoButton = 'Registrar'
        this.colorButton = 'blue darken-3'
      }
    },
    processStep() {
      if (this.wizardStep === this.wizardLength) {
        this.registrar()
      } else {
        this.goNext()
      }
    },
    async registrar() {
      this.panelBusy()

      if (this.onlySignDocs) {
        this.signAccountDocs()
        return
      }

      let data = this.account
      data.identity = this.tknIdentityId

      let respuesta = await this.signup(data)
      if (respuesta.success) {
        this.markOnlySignDocs()
        this.signAccountDocs()
      } else {
        this.panelUnnocupied()
        if (respuesta.error) {
          pushNotification(
            this.$store,
            `${respuesta.error.message}`,
            'error',
            'left'
          )
        } else {
          pushNotification(
            this.$store,
            `Ocurrió un error al registrar al usuario favor de contactar al administrador.`,
            'error',
            'left'
          )
        }
      }
    },
    checkParamToken() {
      if (this.$route.query.token !== undefined) {
        const convert = new ConvertToken()
        const tokenJson = convert.parseJwt(this.$route.query.token)

        if (
          tokenJson.email == undefined ||
          tokenJson.given_name == undefined ||
          tokenJson.family_name == undefined ||
          tokenJson.extension_CONTPAQiID == undefined
        ) {
          this.$router.push('/')
        }

        this.tknMail = tokenJson.email
        this.tknName = tokenJson.given_name
        this.tknFamilyName = tokenJson.family_name
        this.tknFamilySecondName = tokenJson.extension_family_second_name || ''
        this.tknIdentityId = tokenJson.extension_CONTPAQiID
      } else {
        this.$router.push('/')
      }
    },
    signAccountDocs() {
      this.signAccountDocuments(this.fiel)
        .then(() => {
          this.$router.push({ path: '/dashboard' })
        })
        .catch(err => {
          pushNotification(
            this.$store,
            `${err.response.data.error.message}`,
            'error',
            'left'
          )
        })
        .finally(() => {
          this.panelUnnocupied()
        })
    }
  }
}
</script>
